<vectronic-history
  class="history-pop-out"
  [items]="data.items"
  [types]="data.types"
  [title]="data.title"
  [canModifyComments]="false"
  [showAddComment]="false"
  [showTypeFilter]="false"
  [displayClose]="true"
  (closed)="dialogRef.close()"
/>
